import { vservice } from '@niknevis/vue-modules'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { AdminNoteRoute } from '@/modules/common/note/routes/admin-note.route'
import { NoteIndexRequestModel, NoteRequestModel } from '@/modules/common/note/models/note-request.model'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'

@vservice()
export class AdminNoteService {
  constructor(
    private readonly routes: AdminNoteRoute
  ) {
  }

  getNotes(data: NoteIndexRequestModel): any {
    return HTTP.get(
      this.routes.getNotes(data)
    ).then(result => result.json())
  }

  store(data: NoteRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  update(noteId: number, data: NoteRequestModel) {
    return Inertia.put(
      this.routes.update(noteId),
      data
    )
  }

  destroy(noteId: number) {
    return Inertia.delete(
      this.routes.destroy(noteId)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: DeleteConfirm,
        title: 'حذف خبر',
        message: 'آیا از حذف خبر اطمینان دارید ؟'
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }
}